import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Button } from '@material-ui/core';
import ScrollableContainer from '../../../../utility/ScrollableContainer';

import Title from '../../Title';
import { setTabIndex } from '../../../../../redux/parcel/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ConstraintTables from '../ConstraintTables';

class Nearby extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux state
        nearby: PropTypes.array,
        // Redux dispatch
        dispatchSetTabIndex: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleOverviewClick = this.handleOverviewClick.bind(this);
    }

    handleOverviewClick () {
        const { dispatchSetTabIndex } = this.props;
        dispatchSetTabIndex(0);
    }

    render () {
        const { classes, nearby } = this.props;

        const isLoading = !Boolean(nearby);

        const filteredNearby = nearby && nearby.filter(near =>
            near.id !== null && near.value !== null
        ).sort((firstEl, secondEl) => {
            if (firstEl.value < secondEl.value) return -1;
            if (firstEl.value > secondEl.value) return 1;
            return 0;
        });

        // Aplhabetical Sort
        //     .sort((firstEl, secondEl) => {
        //     if(firstEl.layer.name < secondEl.layer.name) return -1;
        //     if(firstEl.layer.name > secondEl.layer.name) return 1;
        //     return 0;
        // });

        return (
            <ScrollableContainer>
                <div className={classes.root}>
                    <Title
                        title="AREA IMPACTS"
                        skeleton={isLoading}
                    >
                        <Button
                            className={classes.overviewButton}
                            onClick={this.handleOverviewClick}
                        >
                            View site impacts
                        </Button>
                    </Title>
                    <ConstraintTables constraints={filteredNearby} valueLabel="Proximity" />
                </div>
            </ScrollableContainer>
        );
    }
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    },
    overviewButton: {
        ...theme.typography.caption,
        color: theme.palette.primary.light,
        marginRight: 'auto',
        textTransform: 'initial'
    }
});

const mapStateToProps = (state) => {
    const currentPolygon = state.parcelPanel.currentPolygonId && state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    return {
        nearby: currentPolygon && currentPolygon.nearby
    };
};

const mapDispatchToProps = (dispatch) => ({
    dispatchSetTabIndex: (index) => dispatch(setTabIndex(index))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(Nearby);